import { render, staticRenderFns } from "./Dictionaries.vue?vue&type=template&id=1d776f3b&scoped=true&"
import script from "./Dictionaries.vue?vue&type=script&lang=js&"
export * from "./Dictionaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d776f3b",
  null
  
)

export default component.exports